export const toDisplayPhone = (raw?: string): string => {
  const digits = (raw ?? "").replace(/\D/g, "");
  const local = digits.startsWith("1") ? digits.slice(1) : digits;
  if (local.length !== 10) return raw ?? "";
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};

export const toStoredPhone = (display: string): string => {
  const digits = display.replace(/\D/g, "");
  return digits.length === 10 ? `+1${digits}` : `+${digits}`;
};

export const phoneMaskOptions = {
  mask: "(___) ___-____",
  replacement: { _: /\d/ },
  modify: ({ value, data, selectionStart, selectionEnd }: any) => {
    const newValue = value.slice(0, selectionStart) + (data ?? "") + value.slice(selectionEnd);
    return { showMask: !!newValue?.length && /\d/.test(newValue) };
  },
};
